module.exports = __webpack_public_path__ + "img/relacionescolor-tacsa.e91ead4c.png";